import {
    ListHeaderItem, RequestData, getSearch
} from '@/components/common/list';
import { ChangeWordList } from '@/methods/setText';
import { community } from '@/data';
import { SearchKey, LogPageData } from './all.type';

export default null;

function getMenus(basicRouter: string) {
    const menus = [{
        label: WordList.ProperAllTextDoorLogs,
        key: 'doorLogs',
        path: `/${basicRouter}/log?type=doorLogs`
    }, {
        label: WordList.ProperAllTextCallHistory,
        key: 'callHistory',
        path: `/${basicRouter}/log?type=callHistory`
    }, {
        label: WordList.ProperAllTextCapture,
        key: 'capture',
        path: `/${basicRouter}/log?type=capture`
    }, {
        label: WordList.ProperAllTextTemperatureLogs,
        key: 'temperatureLogs',
        path: `/${basicRouter}/log?type=temperatureLogs`
    }, {
        label: WordList.ProperAllTextMotionAlerts,
        key: 'motionAlerts',
        path: `/${basicRouter}/log?type=motionAlerts`
    }];

    return menus;
}

const getLogPageData = (projectType: ProjectType | false = false) => {
    // list header 数据
    const headerDoorLogs: Array<ListHeaderItem> = [
        {
            label: WordList.LogListTanleHappenedOn,
            name: 'CaptureTime'
        }, {
            label: ChangeWordList.PMSetAccessBuildOrDepartment,
            name: 'UnitName'
        }, {
            label: WordList.DeviceLocation,
            name: 'Location',
            type: 'customize'
        }, {
            label: WordList.ProperAllTextInitiatedBy,
            name: 'Initiator'
        }, {
            label: WordList.ProperAllTextApt,
            name: 'RoomNum'
        }, {
            label: WordList.ProperAllTextLogsType,
            name: 'LogType'
        }, {
            label: WordList.LogListTanleAction,
            name: 'CaptureAction'
        }, {
            label: WordList.ProperAllTextKey,
            name: 'KeyNum'
        }, {
            label: WordList.ProperAllTextResponse,
            name: 'Response'
        }, {
            label: WordList.ProperAllTextCapture,
            name: 'SPicUrl',
            type: 'customize'
        }
    ];
    // 办公隐藏apt列
    if (projectType === 'office') {
        headerDoorLogs.splice(4, 1);
    }
    const headerCallHistory: Array<ListHeaderItem> = [
        {
            label: WordList.ProperAllTextHappenedOn,
            name: 'Time'
        }, {
            label: WordList.ProperAllTextCaller,
            name: 'CallerName'
        }, {
            label: WordList.ProperAllTextReceiver,
            name: 'CalleeName'
        }, {
            label: WordList.ProperAllTextCallDuration,
            name: 'IsAnswer'
        }
    ];
    const headerCapture: Array<ListHeaderItem> = [
        {
            label: WordList.ProperAllTextHappenedOn,
            name: 'CaptureTime'
        }, {
            label: WordList.DeliveryDevice,
            name: 'Location'
        }, {
            label: WordList.ProperAllTextInitiatedBy,
            name: 'Initiator'
        }, {
            label: WordList.ProperAllTextAction,
            name: 'CaptureAction'
        }, {
            label: WordList.ProperAllTextCapture,
            name: 'SPicUrl',
            type: 'customize'
        }
    ];
    const headerTemperatureLogs: Array<ListHeaderItem> = [
        {
            label: WordList.ProperAllTextHappenedOn,
            name: 'CaptureTime'
        }, {
            label: WordList.ProperAllTextBodyTemperature,
            name: 'Unit',
            type: 'customize'
        }, {
            label: WordList.ProperAllTextStatus,
            name: 'Status',
            type: 'customize'
        }, {
            label: WordList.DeliveryDevice,
            name: 'Location'
        }, {
            label: WordList.ProperAllTextCapture,
            name: 'SPicUrl',
            type: 'customize'
        }
    ];
    const headerMotionAlerts: Array<ListHeaderItem> = [
        {
            label: WordList.ProperAllTextHappenedOn,
            name: 'CaptureTime'
        }, {
            label: ChangeWordList.PMSetAccessBuildOrDepartment,
            name: 'UnitName'
        }, {
            label: WordList.DeliveryDevice,
            name: 'Location'
        }, {
            label: WordList.ProperAllTextCapture,
            name: 'SPicUrl',
            type: 'customize'
        }
    ];
    const headerAuditLogs: Array<ListHeaderItem> = [
        {
            label: WordList.ProperAllTextHappenedOn,
            name: 'CreateTime'
        }, {
            label: WordList.ProperAllTextInitiatedBy,
            name: 'Operator'
        }, {
            label: WordList.ProperAllTextType,
            name: 'Type'
        }, {
            label: WordList.ProperAllTextAction,
            name: 'Action'
        }
        // , {
        //     label: WordList.ProperAllTextObject,
        //     name: ''
        // }
    ];

    // list requestData 数据
    const doorLogsRequestData: RequestData = {
        url: 'v3/web/common/log/getDoorLogForPM',
        param: getSearch({
            Build: 'all',
            LogType: 'all',
            StartTime: '',
            EndTime: '',
            searchKey: 'Device',
            searchValue: ''
        })
    };
    const callHistoryRequestData: RequestData = {
        url: 'v3/web/common/log/getCallLogForPM',
        param: getSearch(
            {
                StartTime: '',
                EndTime: '',
                Key: ''
            }
        )
    };
    const captureRequestData: RequestData = {
        url: 'v3/web/common/log/getCaptureLogForPM',
        param: getSearch({
            StartTime: '',
            EndTime: ''
        })
    };
    const temperatureLogsRequestData: RequestData = {
        url: 'v3/web/common/log/getTemperatureLogForPM',
        param: getSearch({
            StartTime: '',
            EndTime: '',
            Status: 'all',
            Unit: '0'
        })
    };
    const motionAlertsRequestData: RequestData = {
        url: 'v3/web/common/log/getMotionLogForPM',
        param: getSearch({
            StartTime: '',
            EndTime: ''
        })
    };
    const auditLogsRequestData: RequestData = {
        url: 'v3/web/community/audit/getList',
        param: getSearch({
            Type: 'all',
            BeginTime: '',
            EndTime: '',
            UserType: 'all'
        })
    };

    const logPageData: LogPageData = {
        doorLogs: {
            header: headerDoorLogs,
            requestData: doorLogsRequestData,
            action: false
        },
        callHistory: {
            header: headerCallHistory,
            requestData: callHistoryRequestData,
            action: false
        },
        capture: {
            header: headerCapture,
            requestData: captureRequestData,
            action: false
        },
        temperatureLogs: {
            header: headerTemperatureLogs,
            requestData: temperatureLogsRequestData,
            action: false
        },
        motionAlerts: {
            header: headerMotionAlerts,
            requestData: motionAlertsRequestData,
            showCheck: true,
            defaultAction: ['delete'],
            deleteUrl: 'v3/web/common/log/deleteMotionLogForPM',
            action: []
        },
        auditLogs: {
            header: headerAuditLogs,
            requestData: auditLogsRequestData,
            action: false
        }
    };
    return logPageData;
};

const LogTypeEnum = {
    doorLogs: 1,
    callHistory: 4,
    temperatureLogs: 3,
    capture: 2
};

export {
    getMenus,
    getLogPageData,
    LogTypeEnum
};
